import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Lines, SectionTag } from "../site/Motion";

const HOTSPOTS = [
  { top: "30%", left: "62%", label: "Controlli esterni" },
  { top: "64%", left: "38%", label: "Movimento a bassa velocità" },
];

export function FTouch() {
  return (
    <section id="ftouch" data-testid="ftouch-section" className="relative overflow-hidden border-t border-white/10 bg-black py-28 sm:py-40">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-10">
        <SectionTag index="05" label="Tecnologia F-TOUCH™" />
        <div className="mt-10 grid items-center gap-16 lg:grid-cols-2">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-swapa-yellow">F-TOUCH™</p>
            <h2 className="mt-4 font-display font-extrabold uppercase leading-[0.92] tracking-tight">
              <Lines lines={["Parking at", "your fingertips."]} className="text-4xl text-white sm:text-6xl lg:text-7xl" />
            </h2>
            <Reveal delay={0.25}>
              <p className="mt-8 max-w-lg text-base leading-relaxed text-zinc-400">
                Scendi. SWAPA fa il resto. I comandi fisici integrati nella carrozzeria
                consentono di muovere il veicolo avanti e indietro a bassa velocità
                dall'esterno: per gestire con calma anche il parcheggio più stretto.
              </p>
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.22em] text-zinc-600">
                Step out. Swapa takes it from here.
              </p>
              <Link
                to="/tecnologia#ftouch"
                data-testid="ftouch-discover-cta"
                className="group mt-10 inline-flex items-center gap-3 border border-white/30 px-7 py-3.5 font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:border-swapa-yellow hover:text-swapa-yellow"
              >
                Scopri F-TOUCH™
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </Reveal>
          </div>

          <Reveal className="relative" y={70}>
            <div className="relative overflow-hidden border border-white/10">
              <video
                autoPlay
                muted
                defaultMuted
                loop
                playsInline
                preload="metadata"
                poster="/assets/ftouch-poster.jpg"
                aria-label="F-TOUCH: SWAPA si muove a bassa velocità in un parcheggio stretto con i comandi esterni"
                className="aspect-[4/3] w-full object-cover"
              >
                <source src="/assets/ftouch.webm" type="video/webm" />
                <source src="/assets/ftouch.mp4" type="video/mp4" />
              </video>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/30" aria-hidden="true" />
              {HOTSPOTS.map((h) => (
                <div key={h.label} className="absolute" style={{ top: h.top, left: h.left }}>
                  <span className="block h-3 w-3 rounded-full bg-swapa-yellow animate-pulse-dot" aria-hidden="true" />
                  <span className="mt-2 block whitespace-nowrap border border-white/15 bg-black/70 px-3 py-1.5 font-mono text-[9px] uppercase tracking-[0.18em] text-zinc-200 backdrop-blur-sm">
                    {h.label}
                  </span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
